import { AppInsights } from '@/appInsights';
import { CMPApi } from '@/modules/cmp-api';
import { CommitteeView, EoiFormView } from '@/modules/typescript-cmpApi-client/models';
import store from '@/store';
import { EventEmitter } from 'events';
import { orderBy } from 'lodash';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import EoiWording from '../../assets/config/eoi-wording.json';

@Options({
  props: {
    eoi: {}
  },
  emits: ['update:eoi']
})
export default class Membership extends Vue {
  eoi!: EoiFormView;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  // private selectedVal = null;
  private myCommittees: CommitteeView[] = [];

  private committeeList: any = [];

  private selectedCommittee0: any = {};
  private selectedCommittee1: any = {};
  private selectedCommittee2: any = {};

  private committeeYear = '';

  get pageHeader(): string {
    return "Membership";
    //return EoiWording[0].membership['pageHeader'];
  }

  get pageBody(): string {
    return "";
    //return EoiWording[0].membership.pageBody
  }

  mounted() {
    this.eventCtrl.emit('isLoadingData', true);
    this.eventCtrl.emit('canSubmit', false);
    this.getMyCommittees();
    this.getCommitteeList();
  }



  private getCommitteeList() {
    this.apiService.CodeApi?.apiV1CodeGetCommitteesGet()
      .then((res: any) => {
        this.committeeList = orderBy(res.data.data, 'name', 'asc');
        // check existing eoi value
        this.initCommitteeSelection();
        this.committeeYear = this.eoi.year.committeeYear;
        // disable selected value
        this.resetCommitteeList();
        this.eventCtrl.emit('isLoadingData', false);
      })
      .catch((err: any) => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Committee list: ' + err);
        this.ai.trackException('Error getting Committee list: ' + err);
        this.eventCtrl.emit('isLoadingData', false);
      })
  }

  private initCommitteeSelection() {
    if (this.eoi.committeeMembers[0]) {
      this.selectedCommittee0 = {
        id: this.eoi.committeeMembers[0].committeeId,
        name: this.eoi.committeeMembers[0].committeeName
      };
    }
    if (this.eoi.committeeMembers[1]) {
      this.selectedCommittee1 = { 
        id: this.eoi.committeeMembers[1].committeeId,
        name: this.eoi.committeeMembers[1].committeeName
       };
    }
    if (this.eoi.committeeMembers[2]) {
      this.selectedCommittee2 = { 
        id: this.eoi.committeeMembers[2].committeeId,
        name: this.eoi.committeeMembers[2].committeeName
       };
    }
  }

  private getMyCommittees() {
    this.myCommittees = store.getters.getMyCommittees;
    if (this.myCommittees == null) {
      this.apiService.memberApi?.apiV1MemberGetMyCommitteesGet()
        .then((res: any) => {
          this.myCommittees = res.data.data;
          store.dispatch('setMyCommittees', this.myCommittees);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Committee info: ' + err.response.status);
          this.ai.trackException('Error getting EOI committee info: ' + err);
        })
    }

  }

  private resetCommitteeList() {
    this.eoi.committeeMembers = [];
    if (this.selectedCommittee0.id > 0) {
      const _committee0 = {
        id: 0,
        committeeId: this.selectedCommittee0.id,
        committeeName: this.selectedCommittee0.name
      };
      this.eoi.committeeMembers.push(_committee0);
    }
    if (this.selectedCommittee1.id > 0) {
      const _committee1 = {
        id: 1,
        committeeId: this.selectedCommittee1.id,
        committeeName: this.selectedCommittee1.name
      };
      this.eoi.committeeMembers.push(_committee1);
    }
    if (this.selectedCommittee2.id > 0) {
      const _committee2 = {
        id: 2,
        committeeId: this.selectedCommittee2.id,
        committeeName: this.selectedCommittee2.name
      };
      this.eoi.committeeMembers.push(_committee2);
    }
    // reset the dropdown lists
    this.committeeList.forEach((c: any) => {
      c.disabled = false;
    });

    if (this.eoi.committeeMembers[0]) {
      this.committeeList.forEach((c: any) => {
        if (c.id == this.eoi.committeeMembers[0].committeeId) {
          c.disabled = true;
        }
      });
    }

    if (this.eoi.committeeMembers[1]) {
      this.committeeList.forEach((c: any) => {
        if (c.id == this.eoi.committeeMembers[1].committeeId) {
          c.disabled = true;
        }
      });
    }

    if (this.eoi.committeeMembers[2]) {
      this.committeeList.forEach((c: any) => {
        if (c.id == this.eoi.committeeMembers[2].committeeId) {
          c.disabled = true;
        }
      });
    }

    this.mandatoryCheck();
  }

  private mandatoryCheck() {
    const _canSubmit = this.eoi.isSingleCommitteeOnly !== null && this.selectedCommittee0.id;
    this.eventCtrl.emit('canSubmit', _canSubmit);
  }

  private isEmpty(obj: any) {
    return JSON.stringify(obj) == '{}';
  }
}
